/** Static i18n keys of the membership screens; every value must exist in `translations.json`. */
export const MEMBERSHIP_TEXT = {
  title: 'membership:title',
  menuItem: 'membership:menuItem',
  loadError: 'membership:loadError',
  retry: 'membership:retry',
  noAddressTitle: 'membership:noAddressTitle',
  noAddressText: 'membership:noAddressText',
  selectAddress: 'membership:selectAddress',
  noPlansTitle: 'membership:noPlansTitle',
  noPlansText: 'membership:noPlansText',
  clubUnavailableTitle: 'membership:clubUnavailableTitle',
  clubUnavailableText: 'membership:clubUnavailableText',
  zoneMismatch: 'membership:zoneMismatch',
  pricePerMonth: 'membership:pricePerMonth',
  chargesTitle: 'membership:chargesTitle',
  chargeAttempt: 'membership:chargeAttempt',
  clubSavedTotal: 'membership:clubSavedTotal',
  orderClubSaving: 'membership:orderClubSaving',
  chargesLoadError: 'membership:chargesLoadError',
  showMore: 'membership:showMore',
  subscribe: 'membership:subscribe',
  checkoutConsent: 'membership:checkoutConsent',
  checkoutMember: 'membership:checkoutMember',
  checkoutPlanUnavailable: 'membership:checkoutPlanUnavailable',
  checkoutActivating: 'membership:checkoutActivating',
  activating: 'membership:activating',
  stillProcessing: 'membership:stillProcessing',
  refresh: 'membership:refresh',
  close: 'membership:close',
  updateCard: 'membership:updateCard',
  cancelMembership: 'membership:cancelMembership',
  keepCurrentPlan: 'membership:keepCurrentPlan',
  switchPlan: 'membership:switchPlan',
  notNow: 'membership:notNow',
  cancelTitle: 'membership:cancelTitle',
  keepMembership: 'membership:keepMembership',
  planChangeTitle: 'membership:planChangeTitle',
  saveCard: 'membership:saveCard',
  restoring: 'membership:restoring',
  activeBadge: 'membership:statusActive',
  switching: 'membership:switching',
  switchingNoDate: 'membership:switchingNoDate',
  clubChoosePlan: 'membership:clubChoosePlan',
  clubCancelAnytime: 'membership:clubCancelAnytime',
  clubAddCard: 'membership:clubAddCard',
  clubBack: 'membership:clubBack',
  clubWelcomeTitle: 'membership:clubWelcomeTitle',
  clubContinueShopping: 'membership:clubContinueShopping',
  clubViewMembership: 'membership:clubViewMembership',
  clubPlanTitle: 'membership:clubPlanTitle',
  clubPlanSummary: 'membership:clubPlanSummary',
  clubPlanCard: 'membership:clubPlanCard',
  clubCancelAnyway: 'membership:clubCancelAnyway',
  clubCancelSaved: 'membership:clubCancelSaved',
  clubOrdersSaved: 'membership:clubOrdersSaved',
  clubOrdersManage: 'membership:clubOrdersManage',
  clubUpgradeOrderingTitle: 'membership:clubUpgradeOrderingTitle',
  clubUpgradeGetFreeFrom: 'membership:clubUpgradeGetFreeFrom',
  clubUpgradeGetFreeAlways: 'membership:clubUpgradeGetFreeAlways',
  clubUpgradeYourPlanCovers: 'membership:clubUpgradeYourPlanCovers',
  clubUpgradePlanOnly: 'membership:clubUpgradePlanOnly',
  clubUpgradePayNow: 'membership:clubUpgradePayNow',
  clubUpgradeDifference: 'membership:clubUpgradeDifference',
  clubUpgradeNextCharge: 'membership:clubUpgradeNextCharge',
  clubUpgradeNextChargeNoDate: 'membership:clubUpgradeNextChargeNoDate',
  clubUpgradePerMonth: 'membership:clubUpgradePerMonth',
  clubUpgradeFor: 'membership:clubUpgradeFor',
  clubUpgradeSwitchBack: 'membership:clubUpgradeSwitchBack',
  clubUpgradeNotCovered: 'membership:clubUpgradeNotCovered',
  clubTermsTitle: 'membership:clubTermsTitle',
  clubTermsDelivery: 'membership:clubTermsDelivery',
  clubTermsDiscount: 'membership:clubTermsDiscount',
  clubUpgradeCta: 'membership:clubUpgradeCta',
  clubUpgradeDoneTitle: 'membership:clubUpgradeDoneTitle',
  clubUpgradeDoneText: 'membership:clubUpgradeDoneText',
  clubDone: 'membership:clubDone',
  clubBackToOrder: 'membership:clubBackToOrder',
  clubHomeTitle: 'membership:clubHomeTitle',
  clubHomeTitleAlways: 'membership:clubHomeTitleAlways',
  clubHomeTitleMobile: 'membership:clubHomeTitleMobile',
  clubHomeTitleMobileAlways: 'membership:clubHomeTitleMobileAlways',
  clubHomePublic: 'membership:clubHomePublic',
  clubProfileTitle: 'membership:clubProfileTitle',
  clubProfileTitleAlways: 'membership:clubProfileTitleAlways',
  clubProfilePublic: 'membership:clubProfilePublic',
  clubCartRow: 'membership:clubCartRow',
  clubCheckoutRow: 'membership:clubCheckoutRow',
  clubDeliveryFree: 'membership:clubDeliveryFree',
  cartZoneMismatch: 'membership:cartZoneMismatch',
  clubJoinShort: 'membership:clubJoinShort',
  clubPriceCancelAnytime: 'membership:clubPriceCancelAnytime',
} as const;
